import * as React from 'react'

import {
  CardBody as ChakraCardBody,
  CardBodyProps as ChakraCardCodyProps,
  CardRootProps as ChakraCardProps,
  CardRoot as ChakraCardRoot,
} from '@enechain/ecloud-designsystem'

type Props = ChakraCardProps & {
  children: React.ReactNode
  bodyProps?: ChakraCardCodyProps
}

export const Card: React.FC<Props> = ({ children, bodyProps, ...rest }) => {
  return (
    <ChakraCardRoot
      border="1px solid"
      borderColor="Border.lowEmphasis"
      borderRadius="radiiXl"
      backgroundColor="transparent"
      variant="outline"
      {...rest}
    >
      <ChakraCardBody width="full" padding="6" {...bodyProps}>
        {children}
      </ChakraCardBody>
    </ChakraCardRoot>
  )
}
